import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const BlockIcon = (props) => {
    const { className } = props;
    return (_jsxs("svg", Object.assign({ className: `svg-block-icon ${className}`, fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("circle", { cx: '12', cy: '12', r: '10', stroke: '#E5E5E5', strokeWidth: '4' }), _jsx("line", { stroke: '#E5E5E5', strokeWidth: '4', x1: '4.93344', x2: '19.6905', y1: '18.8211', y2: '4.06413' })] })));
};
BlockIcon.propTypes = {
    className: propStr(),
};
BlockIcon.defaultProps = {
    className: '',
};
export default BlockIcon;
